var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_273)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#FFE812"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_626_273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 155.852V146.875C81 141.073 83.3047 135.509 87.407 131.407C91.5094 127.305 97.0734 125 102.875 125H409.125C414.927 125 420.491 127.305 424.593 131.407C428.695 135.509 431 141.073 431 146.875V155.852L256 265.227L81 155.852ZM261.797 287.403C260.058 288.488 258.05 289.063 256 289.063C253.95 289.063 251.942 288.488 250.203 287.403L81 181.648V365.625C81 371.427 83.3047 376.991 87.407 381.093C91.5094 385.195 97.0734 387.5 102.875 387.5H409.125C414.927 387.5 420.491 385.195 424.593 381.093C428.695 376.991 431 371.427 431 365.625V181.648L261.797 287.403Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_626_273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 262.5,
    fill: "white",
    transform: "translate(81 125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d035e44bd34c11199fb2c0e08314cf66.svg";
export { ForwardRef as ReactComponent };